import React, { useEffect, useState } from 'react'
import { PersistGate } from 'redux-persist/es/integration/react'
import { Provider } from 'react-redux'
import { store, persistor } from '../redux/store'
import Routes from '../../routes'
import AuthService from '../services/AuthService'
import { SessionProvider } from '../contexts/sessionProvider';
import Auth from '../utils/Auth';
import MessageModal from '../components/shared/MessageModal';

function App() {

  //TODO: validar si el token esta activo
  //enviar a refrescar token

  const time = Number(localStorage.getItem("time"));
  const [timer, setTimer] = useState(time);
  const [auth, setAuth] = useState(false);
  function timeLessToRenewSession() {
    const expiringDate = new Date(timer);
    const dateNow = new Date();
    return expiringDate.getTime() - dateNow.getTime();
  }

  useEffect(() => {
    //gonzalo toledo
    // si timer es '0' no necesita correr el timeout no pasa
    if (timer === 0) return;
    // si el tiempo que faltaba para correr el timeout es negativo entonces no pasa
    if(timeLessToRenewSession() < 0) {
      console.log("no entra al timer tiempo faltante es negativo")
      return; 
    }
    //esta función sirve para refrescar el token cada cierto [tiempo - utils/authjs]
    const timeout = setTimeout(async () => {
      const local = localStorage.getItem('userappret') && JSON.parse(localStorage.getItem('userappret'))
      if(!(local && local.token)) return;
      const token = local.token;
      try{
        const refreshResponse = await AuthService.refreshToken(token);
        const { data }  = refreshResponse.response || refreshResponse;
        let jwt_expiration_time = data.jwt_expiration_time;
        // jwt_expiration_time = 0.5; Descomentar para probar el refresco
        if(!data.auth){
          setAuth(true);
          localStorage.removeItem('userappret');
          return;
        }
        local.token = data.token;
        localStorage.setItem('userappret', JSON.stringify(local));

        setTimer(Auth.addTime(jwt_expiration_time));
      }catch(e){
        return e;
      }
   
   
    }, timeLessToRenewSession());
    return () => clearTimeout(timeout)
  }, [timer])

  return (
    <SessionProvider setTimer={setTimer} setAuth={setAuth}>
      <PersistGate loading={<div>cargando ...</div>} persistor={persistor} >
      <MessageModal visible={auth}
        closeModal={()=> setAuth(false)}
        message={'Iniciaste sesión en otro lugar, vuelve a iniciar sesión para continuar.'}
        type={1}
      />
        <div className='app-container'>
          <Routes />
        </div>
      </PersistGate>
    </SessionProvider>

  );
}

export default App;


